const Theme = {
  color: {
    primaryBg: "#1A1A29;",
    accent : "#7562E0",
    boxBg : "#BDBDBD",
    fonst : "#FFFFFF",
  },

  media : {
    tablet : "screen and(max-width: 726px)",
    mobile : "screen and(max-width: 526px)",
  }
};

export default Theme